import { ILicense } from "Dashboard/domain/ILicense";
import { IInvoiceReceivable } from "Dashboard/scenes/Partners/domain/IInvoiceReceivable";
import { IInvoiceReceivablePrint } from "Dashboard/scenes/Partners/domain/IInvoiceReceivablePrint";
import { partnersService } from "Dashboard/scenes/Partners/services/partner.service";
import { settingsService } from "Dashboard/services/settings.service";
import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { useEffect, useState } from "react";
import { FormatDate } from "utils/dateUtils";
import { FormatNumber } from "utils/numberUtils";

export interface ReceivableInvoicePrintProps {
  id?: number;
  invoiceInfo?: IInvoiceReceivable;
}

const ReceivableInvoicePrint = ({ id, invoiceInfo }: ReceivableInvoicePrintProps) => {
  const [invoice, setInvoice] = useState<IInvoiceReceivablePrint>();
  const [license, setLicense] = useState<ILicense>();

  useEffect(() => {
    const fetchData = async () => {
      const inv = await partnersService.getReceivableInvoiceForPrint(4);
      setInvoice(inv);
    };
    const fetchLicense = async () => {
      const licence = await settingsService.getLicense();
      setLicense(licence);
    }

    fetchData();
    fetchLicense();
  }, [id, invoiceInfo]);

  const memorandumLogo = useMemorandumLogo();

  return (
    <section className="receivableInvoicePrint">
      <div className="logo">
        {memorandumLogo && <img src={memorandumLogo} alt="" />}
        {license?.address && <p>{license.address}</p>}
        {license?.mobilePhone && <p>mob {license.mobilePhone}</p>}
        {license?.landlinePhone && <p>tel/fax {license.landlinePhone}</p>}
        {license?.taxId && <p>PIB: {license.taxId}</p>}
        {license?.identificationNumber && <p>MAT br: {license.identificationNumber}</p>}
      </div>
      <p className="header">Faktura - Otpremnica br: {invoice?.receivableId}</p>
      <div className="buyer-info">
        <p>Kupac: {invoice?.forPartner.fullName && invoice?.forPartner.fullName}</p>
        <p>Adresa: {invoice?.forPartner.address && invoice?.forPartner.address} {invoice?.forPartner.municipality && ',' && invoice?.forPartner.municipality.name}</p>
        <p>PIB: {invoice?.forPartner.id && invoice?.forPartner.id}</p>
      </div>
      <table className="receivable-print-table receivables-print-table-header ">
        <tbody>
          <tr>
            <th>r.br</th>
            <th>opis pozicije</th>
            <th>jedinica mere</th>
            <th>količina</th>
            <th>jedinična cena</th>
            <th>ukupna cena</th>
            <th>rabat</th>
          </tr>
        </tbody>
      </table>
      <div className="receivable-print-content">
        <table className="receivable-print-table receivables-table">
          <tbody>
            {invoice?.items.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}.</td>
                  <td>
                    {item.title && <textarea rows={3}>{item.title}</textarea>}
                  </td>
                  <td>{item.unit?.name && item.unit.name}</td>
                  <td>{item.quantity && item.quantity}</td>
                  <td>{item.unitPrice && FormatNumber(item.unitPrice)}</td>
                  <td>
                    {item.quantity &&
                      item.unitPrice &&
                      FormatNumber(item.unitPrice * item.quantity)}
                  </td>
                  <td>
                    {item.rebatePercentage !== 0 && item.rebatePercentage && item.rebatePercentage + "%"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="line"></div>
        <div className="total-section">
          <div className="left">
            <div>
              <label>{invoice?.municipality?.name}</label>
              <p>mesto</p>
            </div>
            <div>
              <label>
                {invoice?.invoiceDate && FormatDate(invoice?.invoiceDate)}
              </label>{" "}
              <p>datum izdavanja</p>
            </div>
            <div>
              <label>{invoice?.dueDate && FormatDate(invoice?.dueDate)}</label>
              <p> datum valute</p>
            </div>
            <div>
              <label>
                od{" "}
                {invoice?.supplyDateStart &&
                  FormatDate(invoice?.supplyDateStart)}
              </label>{" "}
              <p>datum prometa dobara i usluga </p>
            </div>
            <div>
              <label>
                do{" "}
                {invoice?.supplyDateEnd && FormatDate(invoice?.supplyDateEnd)}
              </label>
            </div>
          </div>
          <div className="right">
            <div>
              ukupno bez PDV-a{" "}
              <div>
                {invoice?.subtotal && FormatNumber(invoice?.subtotal)} rsd
              </div>
            </div>
            <div>
              rabat{" "}
              <div>{invoice?.rebate && FormatNumber(invoice?.rebate)} rsd</div>
            </div>
            <div>
              PDV <div>{invoice?.vat && FormatNumber(invoice?.vat)} rsd</div>
            </div>
            <div>
              ukupno za naplatu{" "}
              <div>{invoice?.total && FormatNumber(invoice?.total)} rsd</div>
            </div>
          </div>
        </div>
        <textarea className="payment-instructions" rows={3}>
          {invoice?.paymentInstruction}
        </textarea>
        <div className="signature-section">
          <div>
            <label>OVLAŠĆENO LICE</label>
            <label>{invoice?.authorizedPerson}</label>
          </div>
          <div>
            <label>FAKTURISAO</label>
            <label>{invoice?.invoicedBy}</label>
            <p>jmbg</p>
            <p>br.lk</p>
          </div>
          <div>
            <label>PRIMIO</label>
            <label></label>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReceivableInvoicePrint;
